export const SELECTED_TRAFFIC_METRIC_QUERY_PARAM = "selectedTrafficMetric";
export const SELECTED_ENGAGMENT_METRIC_QUERY_PARAM = "selectedEngagmentMetric";
export const TRAFFIC_ENGAGED_USERS_QUERY_PARAM = "trafficEngagedUsers";
export const ENGAGEMENT_ENGAGED_USERS_QUERY_PARAM = "engagementEngagedUsers";
export const TRAFFIC_MONTH_TO_DATE_QUERY_PARAM = "trafficMonthToDate";
export const ENGAGEMENT_MONTH_TO_DATE_QUERY_PARAM = "engagementMonthToDate";
